<script>
const { VUE_APP_API_HOST } = process.env 

export default {
  methods: {
    getInsights(posts){
      return this.$http
        .post(`${VUE_APP_API_HOST}/insights`, posts, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(res => res, err => err)
    }
  }
}
</script>